import CONSTANTS from '../CONSTANTS';

const initialState = {
  studies: [],
  page: 0,
  lastPage: 1,
  limit: 10,
  totalEntries: 0,
  study: {},
  context: {},
  loadingAiReview: false,
  aiGenerationError: false,
  loadingStudy: false,
  loadingStudyList: false,
  showSentModal: false,
  querySearch: "",
  comingFromDetailView: false,
  kilabScrollValue: 0,
  draftSaved: false,
}
const kiLabReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    
    case CONSTANTS.LAB_EARLY_SET_LIST: 
      return {
        ...state, 
        studies: action.studies.data ? action.studies.data : [], 
        page: action.studies.page ? action.studies.page : 0,
        lastPage: action.studies.lastPage ? action.studies.lastPage : 1,
        limit: action.studies.limit ? action.studies.limit : 10,
        totalEntries: action.studies.total ? action.studies.total : 0,
        loadingStudyList: false
      }

    case CONSTANTS.EARLY_LAB_SET_PAGE_INDEX: {
      return {...state, page: action.page};
    }
    case CONSTANTS.LAB_EARLY_SET_LOADING_STUDIES: 
      return {...state, loadingStudyList: action.val};
    case CONSTANTS.LAB_EARLY_SET_STUDY: 
      return {...state, study: action.study, loadingAiReview: false}
    case CONSTANTS.LAB_EARLY_SET_QUERY:
      return {...state, querySearch: action.query}
    case CONSTANTS.LAB_EARLY_COMING_FROM_DETAILS: {
      const studies = state.studies;
      const index = studies.map(s => s._id).indexOf(action.studyId);

      if (index > -1 && state.study?._id === action.studyId)  {
        if (state.study?.assignedDoctors.length <= 1) {
          studies[index].responsible = {};
        }
      }
      return {...state, comingFromDetailView: action.val}
    }
    case CONSTANTS.LAB_EARLY_SET_CONTEXT:
      return {...state, context: {...action.context}}
    case CONSTANTS.LAB_EARLY_SET_LOADING_STUDY:
      return {...state, loadingStudy: action.val}
    case CONSTANTS.LAB_EARLY_SET_LOADING_AI:
      return {...state, loadingAiReview: action.val}
    case CONSTANTS.LAB_EARLY_SET_AI_GEN_ERROR:
      return {...state, aiGenerationError: action.val}
    case CONSTANTS.LAB_EARLY_SAVE_CONTEXT:
      return {...state, "study.draft.edited": true}
    case CONSTANTS.LAB_EARLY_SAVE_SCROLL:
      return {...state, kilabScrollValue: action.scroll}
    case CONSTANTS.LAB_EARLY_DRAFT_SAVED:
      return {...state, draftSaved: action.value}
    case CONSTANTS.LAB_EARLY_SAVE_DRAFT:
      return {...state, draftSaved: false}

    case CONSTANTS.LAB_EARLY_UPDATE_LOCAL_STUDY: {
      const studies = state.studies;
      const index = studies.map(s => s._id).indexOf(action.studyId);

      if (index > -1) {
        studies[index].responsible = action.doctor;

        if (action.readed && !studies[index].readed) {
          studies[index].readed = Boolean(action.readed);
        }

        return {
          ...state,
          studies: [...studies]
        }
      }
    }
      



    default:
      return state;
  }
};

export default kiLabReducer;
